<template>
  <div class="px-3">
    <v-alert
      dense
      class="mt-4 subtitle-2"
      outlined
      color="warning"
      icon="mdi-alert-circle-outline"
      border="left"
    >
      Pastikan Anda menyimpan data ketika melakukan perubahan dengan menekan
      tombol simpan dibagian kanan bawah sebelum melanjutkan proses pengusulan.
    </v-alert>
    <v-row class="mt-8">
      <v-col cols="12" md="4" sm="6">
      </v-col>
    </v-row>

    <UploadImageDialog
      ref="refUploadDialog"
      @eventUploadSuccess="completeUploadSuccess"
    >
    </UploadImageDialog>
  </div>
</template>

<script>
import { format, parseISO } from "date-fns";
import FileService from "@/services/apiservices/file-service";
import UploadImageDialog from "@/components/utils/UploadImageDialog";

export default {
  name: "FtRegistrasiLayananSummary",
  components: {
    UploadImageDialog,
  },
  props: {
    // itemModified: Object,
  },
  data() {
    return {
      snackBarMesage: "",
      snackbar: false,
      dataSiasn: "",
      transparent: "rgba(255, 255, 255, 0)",
      showSiasnData: false,
      itemPns: {
        id: 1,
        tempatLahir: "Mojokerto",
        tahunGaji: 2021,
        tanggalLahir: "1980-04-05",
        golonganLama: "III/D",
        golonganBaru: "III/A",
        tmtGolonganLama: "2020-08-07",
        tmtGolonganBaru: "2022-09-07",
        riwayatPendidikan: "S-2 Sistem Informasi",
        riwayatTahunPendidikan: 2010,
        satuanKerja: "Pemerintah Kota Palangka Raya",
        gelarDepan: "",
        gelarBelakang: "S.Kom., M.Kom.",
        unitKerja: "Bidang Mutasi Data dan Sistem Informasi Kepegawaian",
        unitKerjaInduk:
          "Badan Kepegawaian dan Pengembangan Sumber Daya Manusia",
        tahunMasaKerjaLama: 12,
        bulanMasaKerjaLama: 5,
        gajiPokokLama: 60000000,
        tahunMasaKerjaBaru: 9,
        bulanMasaKerjaBaru: 6,
        gajiPokokBaru: 100000000,
        jabatanFungsionalUmumLama: "Analisis Tata Usaha",
        tmtJabatanFungsionalUmumLama: "2020-09-10",
        jabatanFungsionalUmumBaru: "Penyusun Rencan Mutasi",
        tmtJabatanFungsionalUmumBaru: "2021-10-10",
        lokasiKerja: "Palangka Raya",
        statusPenyederhanaanBirokrasi: true,
      },
      date: format(parseISO(new Date().toISOString()), "dd-MMM-yyyy"),
      menuDate1: false,
      itemsTahun: [
        { id: 1, description: 2018 },
        { id: 2, description: 2019 },
        { id: 3, description: 2020 },
        { id: 4, description: 2021 },
        { id: 5, description: 2022 },
        { id: 6, description: 2023 },
        { id: 7, description: 2024 },
      ],
      rulesLenght: [
        (v) => !!v || " Tidak Boleh Kosong",
        (v) => v.length <= 255 || "Maksimal 255 Karakter",
        (v) => v.length > 1 || "Harus lebih besar dari 1 karakter",
      ],
      rulesNotEmtpy: [(v) => !!v || "Tidak boleh kosong"],
    };
  },
  computed: {
    itemModified:{
      get(){
        return this.$store.state.FtRegistrasiModule.itemModified
      },
      set(val) {
        this.$store.dispatch('FtRegistrasiModule/itemModified', val)
      }
    },
  },
  watch: {
    itemModified: {
      handler(val) {
        if (val.nip !== "") {
          this.cariPegawaiWithNip(val.nip);
        }
      },
      deep: true,
    },
  },
  methods: {
    showSiasnDataValueChange() {
      this.showSiasnData = false;
      this.dataSiasn = "";
    },
    cariPegawaiWithNip(nip) {
      nip.toString()
      // try{
      //   if (nip !==undefined){
      //   }
      // }catch (e) {
      //   e.toString()
      // }
    },
    showDialogUpload() {
      if (this.itemModified.fdivisionBean !== undefined) {
        if (this.itemModified.id === 0) {
          // this.$emit('eventSaveItemWithoutClose', false)
          this.saveCreateOnly();
        }
        this.$refs.refUploadDialog.showDialog();
      } else {
        this.snackBarMesage = "Pcode, Pname dan Divisi harus diisi dahulu";
        this.snackbar = true;
      }
    },
    completeUploadSuccess: function (val) {
      // console.log(this.itemModified.avatarImage)
      if (
        this.itemModified.avatarImage !== undefined &&
        this.itemModified.avatarImage !== ""
      ) {
        FileService.deleteImage(this.itemModified.avatarImage).then(
          () => {
            // console.log(response.data);
          },
          (error) => {
            console.log(error.response);
          }
        );
      }

      if (val.fileName !== "") {
        this.$refs.refUploadDialog.closeDialog();
        this.itemModified.avatarImage = val.fileName;
        this.saveUpdateOnly();
      }
    },
    saveUpdateOnly() {
      this.$emit("saveUpdateOnly");
    },
    saveCreateOnly() {
      this.$emit("saveCreateOnly");
    },
    lookupImageUrl(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_medium(item.avatarImage);
      }
    },
    lookupImageUrlLazy(item) {
      if (item.avatarImage === undefined || item.avatarImage === "") {
        return "./assets/images/no_image_available.jpeg";
      } else {
        return FileService.image_url_verylow(item.avatarImage);
      }
    },

    computedDateFormattedDatefns(value) {
      return value ? format(parseISO(value), "dd MMM yyyy") : "";
    },
  },
};
</script>

<style scoped>
.show-btns {
  color: blue !important;
  opacity: 1;
}
</style>